export const ArrowRightIconCus = ({ width = 20, height = 20, className = '', ...props }) => {
    return (
        <svg width={width} height={height} viewBox='0 0 20 20' fill='none' className={className} xmlns='http://www.w3.org/2000/svg'>
            <g clipPath='url(#clip0_2050_2148)'>
                <path d='M0.714704 10L19.2861 10' stroke='#7E7E7E' strokeWidth='1.42857' strokeLinecap='round' strokeLinejoin='round' />
                <path d='M14.2861 15L19.2861 10L14.2861 5' stroke='#7E7E7E' strokeWidth='1.42857' strokeLinecap='round' strokeLinejoin='round' />
            </g>
            <defs>
                <clipPath id='clip0_2050_2148'>
                    <rect width='20' height='20' fill='white' transform='translate(20) rotate(90)' />
                </clipPath>
            </defs>

        </svg>
    );
};
